import {EventEmitter} from "events";
import { browserHistory } from 'react-router'

class ModalStore extends EventEmitter {
	constructor() {
		super();
		this.openId = null;
	}
	getOpenId () {
		return this.openId;
	}
	closeModal() {
		this.openId = null;
		this.emit("change");
	}
	openModal(id) {
		this.openId = id;
		browserHistory.push('/calendar')
		this.emit("change");
	}
}

const modalStore = new ModalStore();

export default modalStore;


/** WEBPACK FOOTER **
 ** ./src/stores/ModalStore.js
 **/